import React, { useState ,useEffect, useRef} from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../../Styles/Common.module.css';
import Button from '../../Styles/Button.module.css';
import { Link } from "react-router-dom";
import { IoMdClose } from "react-icons/io";
import { useSelector } from 'react-redux';
import {getJobsListFormData,getCountryListFormData,getStateListByCountryId,getCityListByStateId} from '../../../services/routes.services';
import SubmitCVPopup from "./SubmitCVPopup";
import constants from '../../../services/constants'
import PlaceholderImage from '../../../assest/images/list-img01.png';  // Add a placeholder image
import LoginPopup from "../../Common/Login/UserLogin";
const ViewJobListingPage= ()=>{
    const [jobData, setJobData] =   useState([])
    const [offerPopup, setOfferPopup] = useState(false);
    const [countryFilter, setCountryFilter] = useState('');
    const [stateFilter, setStateFilter] = useState('');
    const [cityFilter, setCityFilter] = useState('');
    const [countryOptions, setCountryOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [categories, setCategories] = useState([]);  // Unique categories for the filter
    const [jobTypes, setJobType] = useState([]);  // Unique categories for the filter
const [selectedCategory, setSelectedCategory] = useState('');  // Select 
const [selectedJobs, setSelectedJobs] = useState('');  // Select 
const [filteredJobs, setFilteredJobs] = useState([]);  // Jobs to display based on filters
const [searchQuery, setSearchQuery] = useState('');
const [selectedJobType, setSelectedJobType] = useState("");
    // pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(6); // State for items per page
    const [sortOrder, setSortOrder] = useState("latest"); // New state for sort order
 const [showPopup, setShowPopup] = useState(false);
 
     //Login Popup
     const [loginShow, setLoginShow] = useState(false);
     const { isAuthenticated, user,token } = useSelector((state) => state.auth);
     const [jobDetailsPopup,setjobDetailsPopup]=useState('');
     const sectionPageingScroll = useRef(null);
    const scrollToSection = (ref) => {
        if (ref && ref.current) {
        ref.current.scrollIntoView({ behavior: "smooth" });
        } else {
        console.error("Ref is not attached to a DOM element");
        }
    };
     const loginCloseHandler = ()=>{
             setLoginShow(false)
     }
     useEffect(()=>{
         if(isAuthenticated === false){
             setLoginShow(true)
         }
     }, []);

    useEffect(() => {
        getJobsListFormData(token)
            .then((res) => {
                const jobList = res.data.job;
                const jobListProfession = res.data.profession;
                const jobTypeList = res.data.jobType;
                setJobData(jobList);
                setFilteredJobs(jobList); 
          // Extract unique categories from the job list
        //   const uniqueCategories = [...new Set(jobList.map(job => job.category))];
          setCategories(jobListProfession);
          setJobType(jobTypeList)
            })
            .catch((error) => {
                console.log(error);
            });
            getCountryListFormData()
            .then((res) => {
              const  dataCountry=res.data.countries;
                setCountryOptions(dataCountry);
                // [...new Set(dataCountry.map(country => country.name))]
            })
            .catch((error) => {
                console.log(error);
            });
            
    }, []);
    useEffect(() => {
        filterJobs();
      }, [searchQuery, selectedCategory, selectedJobType, countryFilter, stateFilter, cityFilter, sortOrder]);
    
      const filterJobs = () => {
        let jobs = [...jobData];
    
        // if (searchQuery) {
        //   jobs = jobs.filter((job) =>
        //     job.title.toLowerCase().includes(searchQuery.toLowerCase())
        //   );
        // // }
        if (selectedCategory) {
          jobs = jobs.filter((job) => job?.category === selectedCategory);
        }
        if (selectedJobType) {
              jobs = jobs.filter((job) => job?.jobType === selectedJobType);
        //   jobs = jobs.filter((job) => job?.jobType === selectedJobType);
        }
       
        if (cityFilter) {
          jobs = jobs.filter((job) => job?.city === cityFilter);
        }
    
        if (sortOrder === "latest") {
          jobs.sort((a, b) => new Date(b.date) - new Date(a.date));
        } else if (sortOrder === "oldest") {
          jobs.sort((a, b) => new Date(a.date) - new Date(b.date));
        }
    
        setFilteredJobs(jobs);
      };
    const handleCategoryChange = (e) => {
        const selectedCategory = e.target.value;
    setSelectedCategory(selectedCategory);

    // Filter jobs based on the selected category
    let filtered = jobData;
    if (selectedCategory !== '') {
      filtered = jobData.filter(job => job.category === selectedCategory);
    }
    
    setFilteredJobs(filtered);
    setCurrentPage(1);
    };
    const handleJobChange = (e) => {
        const selectedJobs = e.target.value;
        setSelectedJobs(selectedJobs);

    // Filter jobs based on the selected category
    let filtered = jobData;
    if (selectedJobs !== '') {
      filtered = jobData.filter(job => job.jobType === selectedJobs);
    }
    
    setFilteredJobs(filtered);
    setCurrentPage(1);
    };
    const handleCountryChange = (e) => {
       
        const selectedCountry = e.target.value;
        setCityOptions([])
        
         // Fetch states based on selected country
         if(selectedCountry!==''){
            getStateListByCountryId(selectedCountry)
        .then((res) => {
            const dataState=res.data;
            setStateOptions(dataState);
         
           
        })
        .catch((error) => {
            console.log(error);
        });
    }
        setCountryFilter(e.target.value);
    };

    const handleStateChange = (e) => {
        const selectedState = e.target.value;
        if(selectedState!==''){
        // Fetch cities based on selected state
        getCityListByStateId(selectedState)
        .then((res) => {
            const dataCity=res.data;
            setCityOptions(dataCity);
        })
        .catch((error) => {
            console.log(error);
        });
    }
        setStateFilter(e.target.value);
    };
    const handleCityChange = (e) => {
        setCityFilter(e.target.value);
    };
    const shoeOfferPopHandler=(jobdata)=>{
        setjobDetailsPopup(jobdata)
        setOfferPopup(true)
    }
    const closeOfferHandler = ()=>{
        setOfferPopup(false)
    }
    const handlePageChange = (pageNumber) => {
        scrollToSection(sectionPageingScroll);
        setCurrentPage(pageNumber);
    };
    
      // Handle sort order change
  const handleSortChange = (e) => {
    const sortOrder = e.target.value;
    setSortOrder(sortOrder);
    
    let sortedJobs = [...filteredJobs];
    if (sortOrder === 'latest') {
      sortedJobs.sort((a, b) => new Date(b.batch) - new Date(a.batch));
    } else if (sortOrder === 'oldest') {
      sortedJobs.sort((a, b) => new Date(a.batch) - new Date(b.batch));
    }
    
    setFilteredJobs(sortedJobs);
  };
  const handleSearch = () => {
    if (searchQuery.trim() === "") {
        // If the search query is blank, show all jobs
        setFilteredJobs(jobData);
    } else {
        // Otherwise, filter jobs based on the search query
        const filtered = jobData.filter(job => {
            const matchesSearch = job.company?.toLowerCase().includes(searchQuery.toLowerCase());
            return matchesSearch;
        });
        
        setFilteredJobs(filtered);
    }
    setCurrentPage(1);
};

const handleButtonClick = () => {
    setShowPopup(true);
  };

  useEffect(() => {
    handleSearch();
}, [searchQuery]);
const handleResetfilter=()=>{
    setSelectedJobType('')
    setSelectedCategory('');
    setSelectedJobs('');
    setCountryFilter('');
    setStateFilter('');
    setCityFilter('');
    
  }
  const handleClosePopup = () => {
    setShowPopup(false);
  };
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentJobs = filteredJobs.slice(indexOfFirstItem, indexOfLastItem);
  
    const totalPages = Math.ceil(filteredJobs.length / itemsPerPage);
    return(
        <div className="loginView">
            {isAuthenticated ? 
             <div>
                <section className={Style.clear + " "+Style.breadcrumb}>
                    <Container>
                    <Row>
                        <Col>
                            <ul>
                                <li><Link to="/">Home </Link></li>
                                <li><Link to='/community'>Community</Link></li>
                                <li><Link to='/jobs'>Jobs</Link></li>
                                <li>View Job Listing</li>
                            </ul>
                        </Col>
                    </Row>
                    </Container>
                </section>
                <div className={Style.pageTitle + ' ' + Style.marginUp90}  ref={sectionPageingScroll}>
                    <Container>
                        <Row>
                            <Col>
                                <div className={Style.sectionTitle}>
                                    <h2>Jobs</h2>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col className={Style.searchArea + ' ' + Style.postffer}>
                                <div className={Style.searchContainer}>
                                    <div className={Style.postButton}>
                                        <Link to="/myjobs" className={Button.greenBtn}>Post Your Jobs</Link>
                                    </div>
                                    <div className={Style.searchInput}>
                                        <input type="text" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                                        <button type="button"  onClick={handleSearch}>Search</button>
                                    </div>
                                    <div className={Style.byYear}>
                                        <select onChange={handleSortChange}>
                                            <option value="latest">Sort By</option>
                                            <option value="latest">Latest</option>
                                            <option value="oldest">Oldest</option>
                                            
                                        </select>
                                        <select  onChange={(e) => setItemsPerPage(e.target.value)}>
                                            <option value="6">Page Size</option>
                                            <option value="20">Show 20 </option>
                                            <option value="50">Show 50</option>
                                            <option value="100">Show 100</option>
                                            
                                        </select>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className={Style.elementPadding80}>
                                    <Row>
                                        <Col md={2}>
                                            <div className={Style.FliterSection}>
                                                <div className={Style.filterHead}>
                                                    {/* <h6><FaFilter /> Filter</h6> */}
                                                    <button type="button" onClick={()=>handleResetfilter()}>Reset</button>
                                                </div>
                                                <div className={Style.filterSelect}>
                                                    <select value={selectedCategory} onChange={handleCategoryChange}>
                                                        <option value="">Select Profession</option>
                                                        {categories.map((category, index) => (
                                                            <option key={category._id} value={category.name}>{category.name}</option>
                                                        ))}
                                                    </select>
                                                    <select value={selectedJobType} onChange={(e) => setSelectedJobType(e.target.value)}>
                                                        <option value="">Select Job Type</option>
                                                        {jobTypes.map((type) => (
                                                            <option key={type._id} value={type._id}>{type.name}</option>
                                                        ))}
                                                        </select>
                                                    {/* <select value={selectedJobs} onChange={handleJobChange}>
                                                        <option value=''>Select Type of Job</option>
                                                        {jobTypes.map((category, index) => (
                                                            <option key={category._id} value={category._id}>{category.name}</option>
                                                        ))}
                                                    </select> */}
                                                    <select value={countryFilter} onChange={(e)=>handleCountryChange(e)}>
                                                        <option value="">Select Country</option>
                                                    
                                                        {countryOptions && countryOptions.map(country => (
                                                            <option key={country.id} value={country.id}>{country.name}</option>
                                                        ))}
                                                    </select>
                                                    <select value={stateFilter} onChange={(e)=>handleStateChange(e)}>
                                                        <option value="">Select State</option>
                                                    
                                                        {stateOptions && stateOptions.map(state => (
                                                            <option key={state.id} value={state.id}>{state.name}</option>
                                                        ))}
                                                    </select>
                                                    <select value={cityFilter} onChange={(e)=>handleCityChange(e)}>
                                                        <option value="">Select City</option>
                                                    
                                                        {cityOptions.map(city => (
                                                            <option key={city.id} value={city.name}>{city.name}</option>
                                                        ))}
                                                    </select>
                                                   
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={10}>
                                            <Row>
                                                {jobData && currentJobs.length > 0 ?(
                                                currentJobs.map((jobDetails,i)=>{
                                                    return(
                                                        <Col md={6} key={i}>
                                                        <div className={Style.offerElement}>
                                                            <figure>
                                                                <img src={constants.IMAGE_BASE_URL+"/business/"+jobDetails?.image}  alt={i}/>
                                                            </figure>
                                                            <div className={Style.offerTitle}>
                                                                <h3>{jobDetails?.designation}</h3>
                                                                <h5>{jobDetails?.company}</h5>
                                                            </div>
                                                            <div className={Style.offerDetails}>
                                                                <table role="none">
                                                                    <tr>
                                                                        <td>Company Name</td>
                                                                        <td>{jobDetails?.company}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Category</td>
                                                                        <td>{jobDetails?.category}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>City</td>
                                                                        <td>{jobDetails?.city}</td>
                                                                    </tr>
                                                                </table>
                                                            </div>
                                                            <button type="button" onClick={()=>shoeOfferPopHandler(jobDetails)} className={Button.greenBtn + ' ' + Style.MoreDtl}>More Details</button>
                                                           
                                                        </div>
                                                    </Col>
                                                    )
                                                })
                                                ) : 
                                                (
                                                    <Col md={10} className={Style.noDataFound}>
                                                        <p>Data not found.</p>
                                                    </Col>
                                                )
                                                }
                                                {offerPopup &&
                                                    <div className={Style.offerPopup}>
                                                        <div className={Style.offerElement}>
                                                            <button onClick={closeOfferHandler} className={Style.closePop}><IoMdClose /></button>
                                                            <figure>
                                                                <img  src={constants.IMAGE_BASE_URL+"/business/"+jobDetailsPopup.image} alt={jobDetailsPopup?.company} />
                                                            </figure>
                                                            <div className={Style.offerTitle}>
                                                                <h3>{jobDetailsPopup?.designation}</h3>
                                                                <h5>{jobDetailsPopup?.company}</h5>
                                                            </div>
                                                            <div className={Style.offerDetails}>
                                                                <table role="none">
                                                                    <tr>
                                                                        <td >Category</td>
                                                                        <td >{jobDetailsPopup?.category}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td >Type of Job</td>
                                                                        <td >
                                                                            
                                                                            {jobTypes.find(jobType => jobType?._id === jobDetailsPopup?.jobType)?.name || "Unknown"}

                                                                            </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td >Experience</td>
                                                                        <td >{jobDetailsPopup?.experience}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td >Website</td>
                                                                        <td >{jobDetailsPopup?.website}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td >Skills</td>
                                                                        <td >{jobDetailsPopup?.skills}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td >Job Description</td>
                                                                        <td >{jobDetailsPopup?.description}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td >CITY</td>
                                                                        <td > {jobDetailsPopup?.city}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td >Alumni Member Name</td>
                                                                        <td > {jobDetailsPopup?.alumniName}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td >Batch</td>
                                                                        <td >{jobDetailsPopup?.batch}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td >Designation</td>
                                                                        <td >{jobDetailsPopup?.designation}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td >Business Email Id</td>
                                                                        <td>{jobDetailsPopup?.email}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td >Business Contact Number</td>
                                                                        <td> {jobDetailsPopup?.phone}</td>
                                                                    </tr>
                                                                </table>
                                                            </div>
                                                            <button type="button" className={Button.greenBtn + ' ' + Style.MoreDtl} onClick={handleButtonClick}>APPLY NOW</button>
                                                        </div>
                                                        <div>
                                                        {showPopup && (

                                                                    <SubmitCVPopup onClose={handleClosePopup} jobId={jobDetailsPopup?._id} tokenData={token}/>)
                                                                    }
                                                        </div>
                                                        
                                                    
                                                    </div>
                                                                
                                                }
                                               
                                            </Row>
                                            <Row>
                                <Col>
                                   


                                            <div className={Button.flextCenterBtn + " " + Style.pagging}>
                                            {/* First Page Arrow */}
                                            <button
                                                onClick={() => handlePageChange(1)}
                                                disabled={currentPage === 1}
                                                className={Style.inactivePage}
                                            >
                                                &laquo;
                                            </button>

                                            {/* Previous Arrow */}
                                            <button
                                                onClick={() => handlePageChange(currentPage - 1)}
                                                disabled={currentPage === 1}
                                                className={Style.inactivePage}
                                            >
                                                &lsaquo;
                                            </button>

                                            {/* Number Buttons */}
                                            {Array.from({ length: totalPages }, (_, i) => {
                                                const page = i + 1;
                                                // Show max 5 buttons centered around current page
                                                if (
                                                    page === 1 ||
                                                    page === totalPages ||
                                                    (page >= currentPage - 2 && page <= currentPage + 2)
                                                ) {
                                                    return (
                                                        <button
                                                            key={page}
                                                            onClick={() => handlePageChange(page)}
                                                            className={currentPage === page ? Style.activePage : Style.inactivePage}
                                                        >
                                                            {page}
                                                        </button>
                                                    );
                                                } else if (
                                                    (page === currentPage - 3 || page === currentPage + 3)
                                                ) {
                                                    return <span key={page}>...</span>;
                                                }
                                                return null;
                                            })}

                                            {/* Next Arrow */}
                                            <button
                                                onClick={() => handlePageChange(currentPage + 1)}
                                                disabled={currentPage === totalPages}
                                                className={Style.inactivePage}
                                            >
                                                &rsaquo;
                                            </button>

                                            {/* Last Page Arrow */}
                                            <button
                                                onClick={() => handlePageChange(totalPages)}
                                                disabled={currentPage === totalPages}
                                                className={Style.inactivePage}
                                            >
                                                &raquo;
                                            </button>
                                        </div>

                                </Col>
                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
            : loginShow && <LoginPopup onClose={loginCloseHandler} /> }
        </div>
    )
}

export default ViewJobListingPage;